// extracted by mini-css-extract-plugin
module.exports = {"minus-button":"_1VqZzQ"};